import * as actionTypes from "Redux/Actions/actionTypes";

const getBundleProductRelation = (requestData, callback = () => {}) => ({
  type: actionTypes.GET_BUNDLE_PRODUCT_RELATION,
  data: requestData,
  callback,
});
export default getBundleProductRelation;
